import { deviceInfoApi, deviceOpenApi } from "../../../api/api";

const actions = {
    async identidyResultAction(context, params) {
        try {
            const paramsLength = Object.keys(params).length;
            // 根據傳進來的params個數，來判斷要打哪個api
            let result = null;
            if( paramsLength === 1 ) {
                result = await deviceInfoApi(params)}
            else {
                result = await deviceOpenApi(params)
            }

            // const result = paramsLength === 1 ?  await deviceInfoApi(params) : await deviceOpenApi(params);

            return new Promise((resolve, reject) => {
                if (result.status === 200) {
                    context.dispatch('identidyOpenStatus/updateOpenStatusAction', result.data.opened, { root: true });
                    context.commit('identidyResultMutation', result.data);
                    resolve({
                        status: result.status,
                        opened: result.data.opened,
                    });
                }
                else {
                    reject(result.status);
                }
            });

        } catch (error) {
            console.log(error);
        }
    },
};

export default actions;
